export class Visible{
	init(){
		var elem = $('.features-list__item, .features-list-item, .features-list-submenu, .image, .articles-list__item, .ex-text, .ask-adviser, .form');

		elem.each(function() {
			var $this = $(this),
				elemVisible = $this.visible(true, 'vertical');

			if(elemVisible){
				$this.addClass('on-screen', elemVisible);
				setTimeout(function() {
					$this.addClass('triggered');
				}, 500);
			}
		});


		$(window).scroll(function() {
			elem.each(function() {
				var $this = $(this),
					elemVisible = $this.visible(true, 'vertical');

				if(elemVisible){
					$this.addClass('on-screen', elemVisible);
					setTimeout(function() {
						$this.addClass('triggered');
					}, 500);
				}
			});
		});
		this.delay($('.articles-list--blog .articles-list__item'));
		this.delay($('.features-list .features-list__item'));
		this.delay($('.gallery--home .gallery--home__item'));
		this.delay($('.offer .col-12'));
	}
	delay(elem){
		elem.each(function(index) {
			$(this).css('transition-delay', (300+(250*index) + 'ms'));
		});
	}
}